var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabReportOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#04B7B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5149 6.21249H20.2375V5.45805C20.2375 5.21106 20.0396 5 19.7805 5H12.2148C11.9557 5 11.7579 5.21106 11.7579 5.45805V6.21249H7.48049C7.22611 6.21249 7 6.41457 7 6.66158V26.542C7 26.7889 7.22612 27 7.48523 27H24.5148C24.7739 27 25 26.7889 25 26.542V6.66158C24.9953 6.41459 24.7692 6.21249 24.5148 6.21249H24.5149ZM12.7003 6.66158V5.89815H19.2952V7.42502H12.7003V6.66158ZM24.0531 26.1063H7.94229V7.11035H11.7581V7.86479C11.7581 8.11178 11.9559 8.32284 12.215 8.32284H19.7807C20.0398 8.32284 20.2376 8.11177 20.2376 7.86479V7.11035H24.0534L24.0531 26.1063Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1566 13.4427H12.7005C12.9596 13.4427 13.1716 13.2406 13.1716 12.9936V10.5686C13.1716 10.3216 12.9596 10.1195 12.7005 10.1195H10.1566C9.89756 10.1195 9.68555 10.3216 9.68555 10.5686V12.9936C9.68555 13.2406 9.89753 13.4427 10.1566 13.4427ZM10.6278 11.0177H12.2294V12.4996H10.6278V11.0177Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8955 10.5686C14.8955 10.8156 15.1075 11.0177 15.3666 11.0177H21.6742C21.9333 11.0177 22.1453 10.8156 22.1453 10.5686C22.1453 10.3216 21.9334 10.1195 21.6742 10.1195H15.3666C15.1075 10.1195 14.8955 10.3216 14.8955 10.5686Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5181 13.3976C18.7772 13.3976 18.9892 13.1955 18.9892 12.9485C18.9892 12.7015 18.7773 12.4994 18.5181 12.4994H15.3666C15.1075 12.4994 14.8955 12.7015 14.8955 12.9485C14.8955 13.1955 15.1075 13.3976 15.3666 13.3976H18.5181Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7356 21.8851H15.8984L15.3566 19.8193C15.3048 19.6307 15.1352 19.496 14.9327 19.4825C14.7301 19.4691 14.5369 19.5813 14.4615 19.7655L13.1331 22.9179L12.8316 21.6381C12.7845 21.4315 12.5913 21.2923 12.3699 21.2923H10.1606C9.90146 21.2923 9.68945 21.4944 9.68945 21.7414C9.68945 21.9884 9.90144 22.1905 10.1606 22.1905H11.9931L12.5395 24.5436C12.5867 24.7367 12.7562 24.8759 12.9635 24.8894H13.0012C13.1943 24.8894 13.3686 24.7771 13.4393 24.6065L14.7913 21.3866L15.0693 22.4419C15.1211 22.644 15.3095 22.7787 15.5262 22.7787H17.7356C17.9947 22.7787 18.2067 22.5766 18.2067 22.3296C18.2067 22.0826 17.9947 21.8851 17.7356 21.8851H17.7356Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6748 14.9692H10.1664C9.90732 14.9692 9.69531 15.1713 9.69531 15.4183C9.69531 15.6653 9.9073 15.8674 10.1664 15.8674H21.6748C21.9339 15.8674 22.1459 15.6653 22.1459 15.4183C22.1459 15.1713 21.9339 14.9692 21.6748 14.9692Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6748 17.3947H10.1664C9.90732 17.3947 9.69531 17.5967 9.69531 17.8437C9.69531 18.0908 9.9073 18.2928 10.1664 18.2928H21.6748C21.9339 18.2928 22.1459 18.0908 22.1459 17.8437C22.1459 17.5967 21.9339 17.3947 21.6748 17.3947Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6742 23.996H18.8383C18.5792 23.996 18.3672 24.1981 18.3672 24.4451C18.3672 24.6921 18.5792 24.8942 18.8383 24.8942H21.6742C21.9333 24.8942 22.1453 24.6921 22.1453 24.4451C22.1453 24.1981 21.9333 23.996 21.6742 23.996Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReportOn);
export default __webpack_public_path__ + "static/media/labReportOn.627ae9209fc11be21cd98c8efc65c28d.svg";
export { ForwardRef as ReactComponent };